import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, useParams } from 'react-router-dom';
import apiClient, { IMAGE_BASE_URL } from '../../utils/api-client';
import PageHeader from './../Common/PageHeader';
import './SingleBlogPage.css';

const SingleBlogPage = () => {
  const { b_slug } = useParams();
  const [blog, setBlog] = useState({});
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [relatedBlogs, setRelatedBlogs] = useState([]);

  useEffect(() => {
    apiClient
      .get(`/blog/${b_slug}`)
      .then((res) => {
        setBlog(res.data.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setIsLoading(false);
      });
  }, [b_slug]);

  useEffect(() => {
    apiClient
      .get('/blog')
      .then((res) => {
        setRelatedBlogs(res.data.data.data);
      })
      .catch((err) => {
        setError(err.message);
      });
  }, [blog]);
console.log(relatedBlogs)
  return (
    <>
      <Helmet>
        <title>{blog.meta_title}</title>
        <meta name="description" content={blog.meta_desc} />
        <meta name="keywords" content={blog.keywords} />
        {/* Add more meta tags if needed */}
      </Helmet>

      <PageHeader title="Blog Details" />
      <div className="page-section pt-md-5">
        <div className="container-fluid">
          <div className="row">
            {/* Blog Content */}
            <div className="col-12 col-lg-8 mb-5 mb-lg-0">
              <div className="blog-single-wrap">
                {/* Blog Header */}
                <div className="header mb-4">
                  <div className="post-thumb">
                    <img
                      className="img-fluid rounded shadow-sm"
                      src={`${IMAGE_BASE_URL}/${blog.b_image}`}
                      alt={blog.b_title || 'Blog Post Image'}
                      onError={(e) => {
                        e.target.onerror = null; // Prevent looping
                        e.target.src =
                          'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Image_not_available.png/640px-Image_not_available.png'; // Fallback image
                      }}
                    />
                  </div>
                </div>

                {/* Blog Title */}
                <h1
                  style={{
                    maxWidth:
                      window.innerWidth > 578
                        ? '100%'
                        : 'clamp(250px, 30vw, 300px)',
                  }}
                  className="post-title fw-bold mb-4 text-truncate"
                >
                  {blog.b_title}
                </h1>

                {/* Blog Content */}
                <div
                  className="post-content fs-5 lh-lg"
                  dangerouslySetInnerHTML={{
                    __html: blog.b_long_desc,
                  }}
                />
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-12 col-lg-4">
              {/* Categories Widget */}
              <div className="widget-box p-4 mb-4 border rounded shadow-sm">
                <h4 className="widget-title mb-3">Category</h4>
                <div className="divider mb-3"></div>
                <ul className="list-unstyled">
                  {[
                    'LifeStyle',
                    'Food',
                    'Healthy',
                    'Sports',
                    'Entertainment',
                  ].map((category, idx) => (
                    <li key={idx} className="mb-2">
                      <a className="text-decoration-none text-dark" href="#">
                        {category}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Related Posts Widget */}
              <div className="widget-box p-4 border rounded shadow-sm">
                <h4 className="widget-title mb-3">Related Posts</h4>
                <div className="divider mb-3"></div>

                {relatedBlogs &&
                  relatedBlogs.slice(0, 5).map((item) => (
                    <div
                      className="blog-item d-flex mb-3 align-items-start"
                      key={item.b_slug}
                    >
                      <Link
                        className="post-thumb rounded d-flex justify-content-center align-items-center flex-shrink-0 me-3"
                        to={`/blog-detail/${item.b_slug}`}
                      >
                        <img
                          onError={(e) => {
                            e.target.src =
                              'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Image_not_available.png/640px-Image_not_available.png';
                          }}
                          className="img-fluid rounded"
                          style={{
                            width: '80px',
                            height: '60px',
                            objectFit: 'cover',
                          }}
                          src={`${IMAGE_BASE_URL}/${item.b_image}`}
                          alt={item.b_title}
                        />
                      </Link>
                      <div>
                        <h6 className="post-title mb-0">
                          <Link
                            className="text-decoration-none "
                            to={`/blog-detail/${item.b_slug}`}
                          >
                            {item.b_title}
                          </Link>
                        </h6>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SingleBlogPage;
